const getRandomString = (stringLength = 4) => {
  return Math.random().toString(36).substring(2, stringLength + 2);
};
const generateUniqueId = () => {
  return `${getRandomString(8)}-${getRandomString(4)}-${getRandomString(4)}`;
};
export {
  generateUniqueId as g
};
//# sourceMappingURL=uuid-7d2e5892.mjs.map
